var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9c0-4.962-4.037-9-9-9m0 16.364c-4.06 0-7.364-3.304-7.364-7.364S4.94 1.636 9 1.636 16.364 4.94 16.364 9 13.06 16.364 9 16.364"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 4a1 1 0 1 0 1 1c0-.551-.449-1-1-1m-.143 3A.866.866 0 0 0 8 7.875v5.25c0 .483.384.875.857.875a.866.866 0 0 0 .857-.875v-5.25A.866.866 0 0 0 8.857 7"
}))));
export default SvgInfo;